import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="openas"
// Handles combined group/user "Open as" dropdown
export default class extends Controller {
  static targets = ["group", "user"]

  get toggle() {
    return this.element.closest('.dropdown')?.querySelector('[data-bs-toggle="dropdown"]')
  }

  selectGroup(event) {
    event.preventDefault()
    this.groupTarget.value = event.currentTarget.dataset.value
    this.userTarget.value = ''
    this.updateLabel(event.currentTarget.textContent.trim())
  }

  selectUser(event) {
    event.preventDefault()
    this.userTarget.value = event.currentTarget.dataset.value
    this.groupTarget.value = ''
    this.updateLabel(event.currentTarget.textContent.trim())
  }

  clear(event) {
    event.preventDefault()
    this.groupTarget.value = ''
    this.userTarget.value = ''
    this.updateLabel(this.toggle?.dataset.defaultLabel || 'Open as...')
  }

  updateLabel(name) {
    const el = this.toggle
    if (el) {
      el.innerHTML = '<i class="fa-solid fa-user"></i> ' + name
    }
  }
}
